import React from 'react';

const SidePanelClose = ({ width = 24, height = 24, fill = '#666666', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.5 14.8V9.2C11.5 8.96667 11.4 8.80833 11.2 8.725C11 8.64167 10.8167 8.68333 10.65 8.85L8.2 11.3C8 11.5 7.9 11.7333 7.9 12C7.9 12.2667 8 12.5 8.2 12.7L10.65 15.15C10.8167 15.3167 11 15.3583 11.2 15.275C11.4 15.1917 11.5 15.0333 11.5 14.8ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" fill={fill}/>
  </svg>
);

export default SidePanelClose;
